export class SoundService {
  _successAudio: any = new Audio();
  _completeAudio: any = new Audio();

  constructor() {
    this._successAudio.src = "/platform/assets/sounds/success.mp3";
    this._successAudio.volume = 0.1;
    this._successAudio.load();

    this._completeAudio.src = "/platform/assets/sounds/complete.mp3";
    this._completeAudio.load();
  }

  public playSuccess() {
    this._successAudio.play();
  }

  public playComplete() {
    this._completeAudio.play();
  }
}
